// extracted by mini-css-extract-plugin
export default {"card":"Tips_card__2a3RD","container":"Tips_container__Rsq7D"};